import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://c7bc031ef10f23c119c3bfdf40a702f2@o4510131353616384.ingest.de.sentry.io/4510131354665040",
  release: `degaus-web@${__COMMIT_HASH__}`,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [],
});
